import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';

export const CustomFieldsDetailDirectiveModule = angular
  .module('acme.common.directive.customFieldsDetail', [])
  .directive('customFieldsDetail', [
    function CustomFieldsDetailDirective() {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/customFields/detail/detail.tpl.html',
        scope: {
          viewFields: '=',
        },

        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function CustomFieldsDetailController($scope: IScope & { customFieldsDetail: TODO; viewFields: TODO[] }) {
            $scope.customFieldsDetail = {
              init: function () {},

              hasFields: function () {
                console.log('CustomFieldsDetail::hasFields', $scope.viewFields);
                return $scope.viewFields instanceof Array && $scope.viewFields.length > 0;
              },
            };
          },
        ],
      };
    },
  ]).name;
